import Swiper, { Navigation, Autoplay } from 'swiper';

export function carruselListados() {
    let totalImagenes = document.querySelectorAll('.carrusel-encabezado').length;

    if (totalImagenes > 0) {
        new Swiper('.carrusel-encabezado', {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            centerInsufficientSlides: true,
            spaceBetween: 0,
            loop: true,
            createElements: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".carrusel-encabezado__siguiente",
                prevEl: ".carrusel-encabezado__anterior",
            }
        });
    }
}